
<template>
    
<div class="container-fluid">
    <div class="panel panel-info">
      <div style="text-align: left" class="p-3 mb-2 bg-secondary text-white">
          
        <b>View Certificate :</b>
      </div>
<html>
<head>
    <meta name="viewport" content="width=device-width, initial-scale=1">
<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">
  <title>Register Form</title>
</head>
<body>
<form class="example" action="/action_page.php">
  <table>
   <!-- <tr>
    <td>Name :</td>
    <td><input type="text"></td>
   </tr> -->
   <tr>
    <td>Tag No :
        
    </td>
    
    <td>
     <!-- <select>
      <option>91</option>
      
     </select> -->
     <input type="number">
     <button type="submit" id="btn1"><i class="fa fa-search"></i></button>
    </td>
    
   </tr>
  
   <tr>
    <td>Type:</td>
    <td><input type="text">
    </td>
     
   </tr>
   <tr>
    <td>Breed :</td>
    <td><input type="text"></td>
   </tr>
   
   <tr>
    <td>Age :</td>
    <td><input type="email"></td>
   </tr>
   <!-- <tr>
    <td>Vehicle Type :</td>
    <td><input type="email"></td>
   </tr>
    <tr>
    <td>Driver Name :</td>
    <td><input type="email"></td>
   </tr> -->
   
   <tr>
    
   </tr>
   <td></td>
   <td> </td>
       <td></td>
  
  </table>
  <button type="submit" style="float: center" class="btn btn-secondary">View Medical Certificate</button>&nbsp;
    <button type="Add" style="float: right" class="btn btn-secondary">Add</button>
 </form>
</body>
</html>
    </div>
</div>
</template>
<script>

import * as _ from "lodash";
import DatePicker from "vue2-datepicker";
//import ApplicationFilter from "../components/ApplicationFilter.vue";
//import MarksEntry from "../components/MarksEntry.vue";
//alert(1);
export default {
     components: { DatePicker},
};
</script>

<style>
table {
  font-family: arial, sans-serif;

  width: 100%;
}

td,
th {
  border: 0px solid #dddddd;
  text-align: left;
  padding: 2px;
}
.mycard {
  padding-top: 5px;
  padding-bottom: 5px;
}
#btn1 {
  
  
  width: 10%;
  height:5%;
  padding: 2px;
  background: #2196F3;
  color: white;
  font-size: 17px;
  border: 1px solid grey;
  border-left: none;
  cursor: pointer;
}
</style>
